package one.healthium.reminders.ui

import androidx.compose.runtime.Composable
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LifecycleEventEffect
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun RemindersBloc(content: @Composable () -> Unit) {
    val viewModel = koinViewModel<RemindersViewModel>()

    LifecycleEventEffect(Lifecycle.Event.ON_RESUME) {
        viewModel.scheduleEvents()
    }

    content()
}